import { AffiliateDetails } from "@/types/affiliate";
import { adminApi } from "../../lib/axios";
import { PaginatedResponse } from "./admin.service";

export type AutomationMetric = "AFFILIATES" | "REVENUE";

export interface AffiliateRewardConfigurationRule {
  id: string;
  rewardName: string;
  rewardTypes: string[];
  earningThreshold: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateAffiliateRewardRuleInput
  extends Omit<
    AffiliateRewardConfigurationRule,
    "id" | "createdAt" | "updatedAt"
  > {}

export interface UpdateAffiliateRewardRuleInput
  extends Partial<
    Omit<AffiliateRewardConfigurationRule, "id" | "createdAt" | "updatedAt">
  > {}

export const adminAffiliateRewardsService = {
  async list(): Promise<AffiliateRewardConfigurationRule[]> {
    try {
      const res = await adminApi.get("affiliate-rewards/config");
      return res.data.data || res.data.items || res.data || [];
    } catch (error: any) {
      console.error("Error fetching affiliate reward conditions:", error);
      return [];
    }
  },

  async create(
    input: CreateAffiliateRewardRuleInput
  ): Promise<AffiliateRewardConfigurationRule> {
    const res = await adminApi.post("affiliate-rewards/config", input);
    return res.data.data || res.data.item || res.data;
  },

  async update(
    id: string,
    input: UpdateAffiliateRewardRuleInput
  ): Promise<AffiliateRewardConfigurationRule> {
    const res = await adminApi.patch(`affiliate-rewards/config/${id}`, input);
    return res.data.data || res.data.item || res.data;
  },

  async remove(id: string): Promise<{ success: boolean; message?: string }> {
    const res = await adminApi.delete(`affiliate-rewards/config/${id}`);
    return { success: true, message: res.data?.message };
  },
  async getAffiliates(): Promise<PaginatedResponse<AffiliateDetails>> {
    const res = await adminApi.get("affiliate-rewards/get-affiliates");
    return res.data;
  },
};

export default adminAffiliateRewardsService;
